import React, {Fragment} from 'react';
import Box from '../layout/Box';
import TextInput from '../form/TextInput';
import TextArea from '../form/TextArea';
import createEditor from '../form/ComponentEditor';
import SelectorGrid from "../form/SelectorGrid/SelectorGrid";
import classNames from "classnames";
import GroupPrivileges from '../form/GroupPrivileges';

class GroupEditor extends React.Component {

    render() {
        const sortable = true;
        const filterable = true;
        return (
            <Fragment>
                <Box
                    theme="default"
                >
                    <SelectorGrid
                        loading={this.props.isLoading}
                        componentConfig={this.props.componentConfig}
                        view="list"
                        columns={ {
                            "id": {width: 1, sortable, filterable},
                            "name": {header: 'Név', width: 2, sortable, filterable },
                            "description": {header: 'Leírás', width: 2, sortable, filterable }
                        } }
                        pageSize={5}
                        orderBy={{field: this.props.componentConfig.idfield, direction: "DESC"}}
                        selection={this.props.selection}
                        onSelectionChange={ (selection) => this.props.loadForm(selection.value) }
                    />
                </Box>
                <Box
                    theme="default"
                    footer={[
                        <button key="0" type="button" disabled={ !this.props.dirty || this.props.isLoading } className={classNames("btn pull-right btn-primary", {"disabled": !this.props.dirty || this.props.isLoading})} onClick={ this.props.saveForm }>
                            Mentés
                        </button>,
                        <button key="1" type="button" disabled={this.props.isLoading} className={classNames("btn pull-left btn-default", {"disabled": this.props.isLoading})} onClick={ this.props.pristineForm }>
                            Új
                        </button>
                    ]}
                >
                    <form onSubmit={ this.props.handleSubmit }>
                        <div className="row form-row">
                            <div className="col-sm-4 col-sm-push-8">
                                <TextInput {...this.props.getFieldProps(this.props.componentConfig.idfield)} name={this.props.componentConfig.idfield} value={ this.props.values[this.props.componentConfig.idfield] } label="Kód" role="idfield"/>
                            </div>
                            <div className="col-sm-8 col-sm-pull-4">
                                <TextInput {...this.props.getFieldProps("name")} name="name" value={ this.props.values.name} label="Név" saveChanges={ this.props.setFieldValue }/>
                            </div>
                        </div>
                        <div className="row form-row">
                            <div className="col-sm-12">
                                <TextArea {...this.props.getFieldProps("description")} name="description" value={ this.props.values.description || ''} label="Leírás" saveChanges={ this.props.setFieldValue }/>
                            </div>
                        </div>
                        { this.props.values.id && <div className="row form-row">
                            <div className="col-sm-12">
                                <GroupPrivileges {...this.props} {...this.props.getFieldProps("privileges")} label="Jogosultság kezelés" />
                            </div>
                        </div>}
                    </form>
                </Box>
            </Fragment>
        );
    }
}

export default createEditor({componentName: "Group", WrappedComponent: GroupEditor});